import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  setRockedCurriculumSelectedRole,
  setRockedCurriculumSidebar,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import ShowProgress from '../ui/Backdrop';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListCurriculum({ filterArray }) {
  const classes = SideBarListStyles();
  const dispatch = useDispatch();
  const roleSelected = useSelector((state) => state.rockedCurriculumData.selectedRole);

  const fetchSidebarList = async () => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.RC_DEP_ROLES);
      dispatch(setRockedCurriculumSidebar(res));
      if (!_isEmpty(res)) {
        handleListItemClick(res[0]);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    fetchSidebarList();
  }, []);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});
  useEffect(() => {
    myRefs[roleSelected?.id]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [roleSelected, filterArray]);

  const handleListItemClick = async (user = {}) => {
    dispatch(showProgress(true));
    if (!_isEmpty(user)) {
      dispatch(setRockedCurriculumSelectedRole(user));
    }
    dispatch(showProgress(false));
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {(filterArray || []).map((data) => (
          <div key={data.id} className={roleSelected.id === data.id ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.id}`}
              key={data.id}
              ref={myRefs[data.id]}
              button
              selected={roleSelected.id === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`${
                        roleSelected.id === data.id ? classes.listTextSelected : classes.listTextNonSelected
                      }`}
                    >
                      {data.title}
                    </p>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <ShowProgress />
    </div>
  );
}
